/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { MutableRefObject, useEffect, useState } from 'react';

export const useDetectOutsideClick = (ele: MutableRefObject<any>, initialState: boolean) => {
    const [isActive, setIsActive] = useState(initialState);

    useEffect(() => {
        const pageClickEvent = (e: any) => {
            if (ele.current !== null && !ele.current.contains(e.target)) {
                setIsActive(prev => !prev);
            }
        };
        if (isActive) {
            window.addEventListener('click', pageClickEvent);
        }

        return () => {
            window.removeEventListener('click', pageClickEvent);
        };
    }, [isActive, ele]);

    return [isActive, setIsActive] as const;
};
